import React, { useState } from 'react';
import { makeStyles, useTheme } from "@material-ui/core/styles";

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
// import IconButton from "@material-ui/core/IconButton";
// import Brightness from '@material-ui/icons/Brightness7';
// import Dark from '@material-ui/icons/Brightness4';
import Cookies from 'js-cookie';
import axios from '../../utils/axiosConfig';
import IPCapture from './ImageProctoringCapture';
import { LoaderContained } from '../LoaderProcessing';
const useStyles = makeStyles(theme => ({
    root: {
        display: "flex"
    },
    paper: {
        padding: theme.spacing(2)
    },
    title: {
        flexGrow: 1,
    }
}));

export default function Instruction(props) {
    const classes = useStyles();
    // const theme = useTheme();
    const { examDetail, setViewInstruction, testData, setTestData } = props;
    let token = Cookies.get('token');

    const [hidden, setHidden] = useState(false);
    const [loading, setLoading] = useState(false);
    const [monitorFlag,setMontorFlag] = useState(examDetail[0].monitoringflag)
    const closeInstruction = () => {

        window.location.replace('/v2/user/dashboard');

    }

    window.onbeforeunload = function (e) {
        e.preventDefault();
    }

    React.useEffect(()=> {
        if(examDetail[0].status == '001'){
            setMontorFlag(false)
            setHidden(false)
        }
    })

    const resumeTest = async () => {
        setLoading(true)
        if (examDetail[0].status === '000') {
            setTestData({ quesData: testData, examDetail: examDetail })
            // window.localStorage.setItem(examDetail[0].id,testData)
            let stringifyTestData = JSON.stringify(testData)
            let encodedTestData = encodeURIComponent(btoa(encodeURIComponent(stringifyTestData)))
            let stringifyExamDetail = JSON.stringify(examDetail)
            let encodedExamDetail = encodeURIComponent(btoa(encodeURIComponent(stringifyExamDetail)));
            axios.post('/test/startExam', {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                }, id: examDetail[0].id, quesData: encodedTestData, examDetail: encodedExamDetail
            }).then(updateStatus => {

                examDetail[0].status = '001';
                setViewInstruction(false);
                setLoading(false)
            }).catch(error => {

            })
        } else if (examDetail[0].status === '001') {
            let resumeData;
            resumeData = window.localStorage.getItem(examDetail[0].id)
            let decodedData = decodeURIComponent(atob(decodeURIComponent(resumeData)))
            let resumeTestData = JSON.parse(decodedData)
            setTestData({ quesData: resumeTestData[0] ? resumeTestData[0].quesData : resumeTestData.quesData, examDetail: resumeTestData[0] ? resumeTestData[0].examDetail : resumeTestData.examDetail })

            if (resumeTestData[0]) {

                let stringifyExamDetail = JSON.stringify(resumeTestData[0].examDetail[0])
                var encodedExamDetail = encodeURIComponent(btoa(encodeURIComponent(stringifyExamDetail)))

                let stringifyQuesData = JSON.stringify(resumeTestData[0].quesData)
                var encodedQuesData = encodeURIComponent(btoa(encodeURIComponent(stringifyQuesData)))
            }
            else {
                let stringifyExamDetailNew = JSON.stringify(resumeTestData.examDetail[0])
                var encodedExamDetailNew = encodeURIComponent(btoa(encodeURIComponent(stringifyExamDetailNew)))

                let stringifyQuesDataNew = JSON.stringify(resumeTestData.quesData)
                var encodedQuesDataNew = encodeURIComponent(btoa(encodeURIComponent(stringifyQuesDataNew)))
            }


            axios.post('/test/resumeExam', {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                }, id: examDetail[0].id, examDetail: resumeTestData[0] ? encodedExamDetail : encodedExamDetailNew, quesData: resumeTestData[0] ? encodedQuesData : encodedQuesDataNew
            }).then(updateStatus => {

                examDetail[0].status = '001';
                setViewInstruction(false);
                setLoading(false)
            }).catch(error => {

            })
        } else {
            setViewInstruction(false);
        }

    }

    return (
        <>

            {/* <Grid container spacing={1} style={{backgroundColor: (props.themeType === 'dark') ? '#303030' : '#FFF', alignContent: 'justify'}}>
                <Grid item xs={12}> */}
            <div id="main-body" style={{ background: "#E5E6E9", maxHeight: "-webkit-fill-available" }}>
                <div className="container-fluid main-wrap">
                    <AppBar position="static" className="col-md-12" color="secondary">
                        <Toolbar style={{ minHeight: "32px" }}>
                            <Typography variant="h6" className={classes.title}>
                                {examDetail[0].instancename}
                            </Typography>
                            {/* <IconButton  onClick={() => props.changeTheme(props.themeType)} aria-label="show 4 new mails" color="inherit">
                                {props.themeType === 'dark' ? <Dark  /> : <Brightness  />}
                            </IconButton> */}
                        </Toolbar>
                    </AppBar>
                </div>
                <div className="row" >
                    <div className="container container-two qa-wrap">
                        <div className="qa-overlay" id="main-layout"></div>
                        <div className="col-md-12 question-box instruction-li" id="layout-2">

                            <div id="inst" dangerouslySetInnerHTML={{ __html: examDetail[0].instruction_text }} /></div></div>
                </div>
                {/* <div style={{textAlign: 'justify'}}>
                        <p>Important</p>
                        <p>Your test will be TERMINATED & considered as complete if you attempt to switch to another window.</p>
                        <p>Use of computer calculator will also be considered as switching window.</p>
                        <p>Please note : Your Test Score will be considered as INVALID.</p>
                    </div> */}
                <div className="instruction-div container qa-wrap ">
                    <div className="qa-overlay" id="main-layout"></div>
                    <div className="col-md-12 question-box" style={{ paddingTop: "0px", paddingBottom: "0px" }} id="layout-2">
                        <h3 style={{ textAlign: "center", color: "#8D0001", marginTop: "10px", marginBottom: "10px" }}><b>Important Information</b></h3>
                        <p style={{ marginBottom: "0px" }}>Your test will be <u><b style={{ color: "#8D0001" }}>TERMINATED</b></u> &amp; considered as complete if you attempt to switch to another window.</p>
                        <p style={{ marginBottom: "0px" }}>Use of computer calculator will also be considered as switching window.</p>
                        <p style={{ marginBottom: "0px" }}>Please note : Your Test Score will be considered as <u><b style={{ color: "#8D0001" }}>INVALID</b>.</u></p>
                        {!hidden && monitorFlag ?
                            <></> : hidden ? <></> :

                                <Grid item xs={12} style={{ textAlign: 'center' }}>

                                    {loading ? <LoaderContained /> :
                                        <Button variant="contained" color="primary" onClick={() => resumeTest()}>
                                            <strong>{examDetail[0].status === '000' ? 'Start' : 'Resume'}</strong>
                                        </Button>
                                    }

                                    {/* <Button variant="contained" style={{marginLeft: '2rem'}} color="primary" onClick={() => closeInstruction()}>
                            <strong>Close</strong>
                        </Button> */}


                                </Grid>

                        }
                    </div>
                </div>
                {monitorFlag != false
                    ?
                    <div className="instruction-div-two container  qa-wrap ">
                        <div className="qa-overlay" id="main-layout"></div>
                        <div className="col-md-12  question-box" style={{ paddingTop: "0px", paddingBottom: "0px" }} id="layout-2">
                            <h3 style={{ textAlign: "center", color: "#8D0001", marginTop: "10px", marginBottom: "10px" }}><b>Web Cam Configurations</b></h3>
                            <p style={{ marginBottom: "0px" }}>This test needs to be conducted under monitored session only. Webcam is <u><b style={{ color: "#8D0001" }}>MANDATORY</b></u>.
                                This test will not start if webcam is not found.</p>
                            <p style={{ marginBottom: "0px" }}>Basic System Requirements : Windows OS 7 and above, iOS High Sierra and above, Chrome 55 and above, Firefox 50 and above</p>
                            <p style={{ marginBottom: "0px" }}>  To snap photo. Please come closer to the camera so that your face is visible inside a circle for AI to detect a face.</p>


                            <Grid item xs={12}>
                                <IPCapture resumeTest={resumeTest} examDetail={examDetail} hidden={hidden} setHidden={setHidden} />

                            </Grid>

                        </div>
                    </div>
                    :
                    <> </>
                }

            </div>


        </>
    );
}